import { forwardRef, Ref } from "react";
import { Button, ButtonProps } from "./ui/button";
import { cn } from "@/lib/utils";

interface ToolbarButtonProps extends ButtonProps {
  className?: string;
}

export default forwardRef(function ToolbarButton(
  { className, ...props }: ToolbarButtonProps,
  ref: Ref<HTMLButtonElement>,
) {
  return (
    <Button
      variant="secondary"
      className={cn("text-sm hover:bg-slate-200", className)}
      {...props}
      ref={ref}
    />
  );
});
